<template>
  <Tabs :model-value="modelValue" @update:model-value="onSelect">
    <TabsList :class="fullwidth ? 'tw:w-full' : undefined">
      <TabsTrigger
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :disabled="disabled || option.disabled"
      >
        {{ option.label }}
      </TabsTrigger>
    </TabsList>
  </Tabs>
</template>

<script setup lang="ts">
import { Tabs, TabsList, TabsTrigger } from '@/shadcn/components/ui/tabs'

export interface SegmentedOption {
  value: string;
  label: string;
  disabled?: boolean;
}

/**
 * A row of mutually exclusive choices, all visible at once.
 *
 * For a small set of options where seeing the alternatives matters as much as the
 * current one — a dropdown would hide them behind a click, and a pair of switches
 * would let two of them be true at the same time.
 */
withDefaults(defineProps<{
  options: SegmentedOption[];
  modelValue?: string;
  disabled?: boolean;
  fullwidth?: boolean;
}>(), {
  fullwidth: false,
})

const emit = defineEmits<{
  (event: 'update:modelValue', value: string): void;
}>()

const onSelect = (value: string | number): void => emit('update:modelValue', String(value))
</script>
